import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PosSalesService {
  private baseURL: string;
  constructor(private http: HttpClient) {
    this.baseURL = environment.apiBaseUrl;
  }

  getPOSVendorList(pOSVendorList): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/POSSales/GetPOSVendorList`;
    return this.http.post<any>(url, pOSVendorList, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  getPOSCustomerList(pOSCustomerListRequest): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/POSSales/GetPOSCustomerList`;
    return this.http.post<any>(url, pOSCustomerListRequest, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  GetPOSShippingList(pOSSearchListRequest): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/POSSales/GetPOSShippingList`;
    return this.http.post<any>(url, pOSSearchListRequest, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  getPOSVendorActiveDiscountPlan(vendorId): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/POSSales/GetPOSVendorActiveDiscountPlan?vendorId=${vendorId}`,
      { observe: 'response' }
    ).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  getCustomerDetailsById(customerId): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/POSSales/GetCustomerDetailsById?customerId=${customerId}`,
      { observe: 'response' }
    ).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  checkMarketCustomerExists(marketCustomerId: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/POSSales/CheckMarketCustomerExists?marketCustomerId=${marketCustomerId}`,
      { observe: 'response' }
    ).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  getInvoiceItemsList(invoiceSeqNo): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/POSSales/GetInvoiceItemsList?invoiceSeqNo=${invoiceSeqNo}`,
      { observe: 'response' }
    ).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  getActiveUniversalDiscount(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/POSSales/GetActiveUniversalDiscount`,
      { observe: 'response' }
    ).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  closeLayawaySale(invoiceNo): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/POSSales/CloseLayaway?invoiceNo=${invoiceNo}`,
      { observe: 'response' }
    ).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  voidLayawaySale(salesReceiptId, reason): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/POSSales/VoidLayawaySale?salesReceiptId=${salesReceiptId}&reason=${reason}`,
      { observe: 'response' }
    ).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  voidEntireLayaway(invoiceNo, reason): Observable<any> {
    return this.http.post<any>(
      `${this.baseURL}/POSSales/VoidEntireLayaway`,
      { InvoiceNo: invoiceNo, Reason: reason },
      { observe: 'response' }
    ).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  savePosItemDetails(pOSSalesDetails): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/POSSales/SavePosItemDetails`;
    return this.http.post<any>(url, pOSSalesDetails, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  savePOSCustomerDetails(pOSCustomerDetail): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/POSSales/SavePOSCustomerDetails`;
    return this.http.post<any>(url, pOSCustomerDetail, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  savePOSShippingDetails(pOSShippingDetails): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/POSSales/SavePOSShippingDetails`;
    return this.http.post<any>(url, pOSShippingDetails, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  getInvoiceList(invoiceSearchFilter): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/POSSales/GetInvoiceList`;
    return this.http.post<any>(url, invoiceSearchFilter, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  getLastInvoiceOfUser(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/POSSales/GetLastInvoiceOfUser`,
      { observe: 'response' }
    ).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  updateInvoiceDetails(invoiceUpdateData): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/POSSales/UpdateInvoiceDetails`;
    return this.http.post<any>(url, invoiceUpdateData, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  getShipperDetailsById(shipperId): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/POSSales/GetShipperDetailsById?shipperId=${shipperId}`,
      { observe: 'response' }
    ).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  getInvoicePaymentDetails(invoiceId): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/POSSales/GetInvoicePaymentDetails?invoiceId=${invoiceId}`,
      { observe: 'response' }
    ).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  getInvoiceSummaryById(marketInvoiceNo): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/POSSales/GetInvoiceSummaryById?marketInvoiceNo=${marketInvoiceNo}`,
      { observe: 'response' }
    ).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  checkBookingForGCVendor(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/POSSales/CheckBookingForGCVendor`,
      { observe: 'response' }
    ).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  checkBookingForBagVendor(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/POSSales/CheckBookingForBagVendor`,
      { observe: 'response' }
    ).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  generatePOSReceipt(posReceiptInputModel): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/POSReceipt/GeneratePOSReceipt`;
    return this.http.post<any>(url, posReceiptInputModel, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  generateGCReceipt(posReceiptInputModel): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/POSReceipt/GenerateGCReceipt`;
    return this.http.post<any>(url, posReceiptInputModel, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  updateInvoiceCardType(invoiceNo, cardType): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/POSSales/UpdateInvoiceCardType?invoiceNo=${invoiceNo}&cardType=${cardType}`,
      { observe: 'response' }
    ).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  updateInvoicePaymentType(invoicePaymentUpdateModel): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/POSSales/UpdateInvoicePaymentType`;
    return this.http.post<any>(url, invoicePaymentUpdateModel, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }
}